export enum ColorType {
    primary = "primary",
    secondary = "secondary",
    success = "success",
    warning = "warning",
    error = "error",
    create = "create",
}
